import script from "./TacticDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./TacticDialog.vue?vue&type=script&setup=true&lang=ts"

import "./TacticDialog.vue?vue&type=style&index=0&id=7fd0929a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fd0929a"]])

export default __exports__